export default "__VITE_ASSET__Dlo_IJla__"